// „Instalează aplicația”: pe telefon/tabletă/PC, platforma poate fi adăugată pe ecranul principal ca o aplicație.
import { useEffect, useState } from "react";

let deferred = null;
const listeners = new Set();

export function initInstall() {
  if (typeof window === "undefined") return;
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; listeners.forEach(f => f()); });
  window.addEventListener("appinstalled", () => { deferred = null; listeners.forEach(f => f()); });
  if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
  }
}

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

/** { canInstall, ios, install() } — canInstall: browserul oferă instalarea; ios: se instalează manual din „Distribuie”. */
export function useInstall() {
  const [, tick] = useState(0);
  useEffect(() => { const f = () => tick(n => n + 1); listeners.add(f); return () => listeners.delete(f); }, []);
  const installed = standalone();
  return {
    canInstall: !installed && !!deferred,
    ios: !installed && isIos(),
    install: async () => { if (!deferred) return; deferred.prompt(); try { await deferred.userChoice; } catch {} deferred = null; listeners.forEach(f => f()); },
  };
}
